import * as React from 'react';
import { BrandButtonSvg, BrandButtonWrapper } from './BrokerHeader.styled';

var BrandButton = function BrandButton(_ref) {
  var site = _ref.site;
  return /*#__PURE__*/React.createElement(BrandButtonWrapper, {
    noStyle: true,
    href: "/",
    trackId: "nav-home",
    trackEventData: {
      label: site
    },
    "aria-label": "Home page"
  }, /*#__PURE__*/React.createElement(BrandButtonSvg, {
    name: "logo-combination",
    "aria-label": "Home page",
    className: "home-button__logo"
  }));
};

export default BrandButton;